export default __webpack_public_path__ + "static/media/chapter-pc.cb56940a.jpg";